import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = 'nominas/descuentos-empleados-deducciones';

/**
 * GET Descuentos Empleados Deducciones
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getDescuentosEmpleadosDeducciones = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Descuento Empleado Deduccion
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getDescuentoEmpleadoDeduccion = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Descuento Empleado Deduccion
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postDescuentoEmpleadoDeduccion = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Descuento Empleado Deduccion
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchDescuentoEmpleadoDeduccion = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Descuento Empleado Deduccion
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteDescuentoEmpleadoDeduccion = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
